

export enum VehicleSide {
    Front = 'Front',
    Back = 'Back',
    RightSide = 'RightSide',
    LeftSide = 'LeftSide',
    Top = 'Top',
    Bottom = 'Bottom'
  }
  
  
  export enum VehiclePresetKeys {
    FrontWindow = '1.1',
    FrontHood = '1.2',
    FrontLeftHeadlight = '1.3',
    FrontRightHeadlight = '1.4',
    FrontBamper = '1.5',
  
    BackWindow = '4.1',
    BackHood = '4.2',
    BackLeftHeadlight = '4.3',
    BackRightHeadlight = '4.4',
    BackBamper = '4.5',
  
    RightSideFront = '2.1',
    RightSideFrontWheel = '2.2',
    RightSideFrontDoor = '2.3',
    RightSideBackDoor = '2.4',
    RightSideBack = '2.5',
    RightSideBackWheel = '2.6',
  
    LeftSideFront = '3.1',
    LeftSideFrontWheel = '3.2',
    LeftSideFrontDoor = '3.3',
    LeftSideBackDoor = '3.4',
    LeftSideBack = '3.5',
    LeftSideBackWheel = '3.6',
  
    TopFrontWindow = '1.1',
    TopFrontHood = '1.2',
    TopRoof = '5.3',
    TopBackWindow = '4.1',
    TopBackHood = '4.2',
  
    BottomFront = '6.1',
    BottomCenter = '6.2',
    BottomBack = '6.3'
  }
  
  
  export enum SVGClasses {
    Hovered = 'hovered',
    HoveredLight = 'hovered-light',
    HoveredDark = 'hovered-dark',
    SelectedLight = 'selected-light',
    SelectedMedium = 'selected-medium',
    SelectedDark = 'selected-dark',
  
    PartialDamage = 'partial-damage',
    FullDamage = 'full-damage',

    PartialDamageLight = 'partial-damage-light',
    FullDamageLight = 'full-damage-light',

    PartialDamageDark = 'partial-damage-dark',
    FullDamageDark = 'full-damage-dark',
  }
  
  export enum DamageType {
    PartialDamage = 'Partial damage',
    FullDamage = 'Full damage',
    NoDamage = 'No damage'
  }

  
  export interface CarSideSelection {
    url: string, 
    side: VehicleSide,
    label: string,
    selectedPresetKey: VehiclePresetKeys
  }

  export const carSideSelections: CarSideSelection[] = [
    {
      url: './../../../../../../assets/images/dismantle-car/front-car.svg',
      side: VehicleSide.Front,
      label: 'Front',
      selectedPresetKey: VehiclePresetKeys.FrontHood
    },
    {
      url: './../../../../../../assets/images/dismantle-car/back-car.svg',
      side: VehicleSide.Back,
      label: 'Back',
      selectedPresetKey: VehiclePresetKeys.BackHood
    },
    {
      url: './../../../../../../assets/images/dismantle-car/right-side-car.svg',
      side: VehicleSide.LeftSide,
      label: 'Left side',
      selectedPresetKey: VehiclePresetKeys.LeftSideFrontDoor
    },
    {
      url: './../../../../../../assets/images/dismantle-car/left-side-car.svg',
      side: VehicleSide.RightSide,
      label: 'Right side',
      selectedPresetKey: VehiclePresetKeys.RightSideFrontDoor
    },
    {
      url: './../../../../../../assets/images/dismantle-car/top-side-car.svg',
      side: VehicleSide.Top,
      label: 'Top',
      selectedPresetKey: VehiclePresetKeys.TopFrontHood
    },
    {
      url: './../../../../../../assets/images/dismantle-car/bottom-side-car.svg',
      side: VehicleSide.Bottom,
      label: 'Bottom',
      selectedPresetKey: VehiclePresetKeys.BottomCenter
    }
  ]